import { handleApiRequest } from '../services/transports';

import { REACT_APP_DAO_DOMAIN } from './base';

export const submitDemandShortage = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage`,
  method: 'post',
  data
});

export const listDemandShortage = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage`,
  method: 'get',
  query
});

export const listShortageIds = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/get-shortage-Ids`,
  method: 'get'
});

export const retriveDemandShortage = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/${id}`,
  method: 'get'
});

export const downloadDemandShortageAttachement = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/download-attachement/${id}`,
  method: 'get'
});

export const shortageReasons = () => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/reasons`,
  method: 'get'
});
export const shortageRequiredActions = () => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/required-actions`,
  method: 'get'
});
export const shortageStatuses = () => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/shortage-statuses`,
  method: 'get'
});

export const shortageSFDAResponses = shType => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/sfda-responses/${shType}`,
  method: 'get'
});

export const sfdaReply = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/sfda-reply`,
  method: 'post',
  data
});

export const demandShortageAssignToUser = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/demand-shortage-assign-to-user`,
  method: 'post',
  data
});

